import writeXlsxFile from "write-excel-file";
import moment from "moment";
import { toast } from "react-toastify";
// service
import { getChat } from "../../../../../utils/services/dashboardSuperScreen";
// utils
import { parseFirestoreDate } from "../../../../../utils/helpers/files/formatDate";

// quantidade de registros buscados por requisição na exportação
const EXPORT_LIMIT = 999;

// formata a data da mensagem para "DD/MM/AAAA - HH:mm" (aceita Timestamp do Firestore ou ISO)
export function formatDate(date) {
  const parsedDate = parseFirestoreDate(date);
  if (!parsedDate) return "";

  return moment(parsedDate).format("DD/MM/YYYY - HH:mm");
}

// atualiza a barra de progresso do WaitExport
function updateProgress(current, total) {
  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  const percentage = (current / total) * 100;

  if (progressBar) progressBar.style.width = `${percentage}%`;
  if (percentageBar) percentageBar.innerHTML = `${percentage.toFixed(0)}%`;
}

// busca todas as páginas de mensagens do chat e gera o arquivo xlsx
export async function createXlsx({
  eventId,
  transmissionID,
  search,
  countData,
  mobileapps,
  setFinishExport,
  setExportInProgress,
}) {
  const schema = [
    {
      column: "ID do Participante",
      type: String,
      value: (chat) => chat.userId,
    },
    {
      column: "Nome do Participante",
      type: String,
      value: (chat) => chat.name,
    },
    {
      column: "Mensagem",
      type: String,
      value: (chat) => chat.msg,
    },
    {
      column: "Data e Hora",
      type: String,
      value: (chat) => formatDate(chat.date),
    },
  ];

  try {
    const allData = [];
    const numberOfRequisitions = Math.ceil(countData / EXPORT_LIMIT);

    for (let page = 1; page <= numberOfRequisitions; page += 1) {
      const res = await getChat({
        eventId,
        transmissionID,
        pageSize: EXPORT_LIMIT,
        offset: page - 1,
        search,
        mobileapps,
      });

      if (!res?.success) {
        throw new Error("Erro ao buscar mensagens do chat.");
      }

      allData.push(...res.data);
      updateProgress(page, numberOfRequisitions);
    }

    if (allData.length > 0) {
      await writeXlsxFile(allData, {
        schema,
        fileName: "Chat.xlsx",
      });
    }

    setTimeout(() => {
      setFinishExport(true);
    }, 1000);
  } catch (error) {
    setExportInProgress(false);
    toast.error("Erro ao exportar mensagens do chat.");
  }
}
